var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlaFlagFacilitet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79,1.8a5.993,5.993,0,1,0,6,5.993A6,6,0,0,0,7.79,1.8Zm0,.751A5.253,5.253,0,0,1,13.042,7.8c0,.036-.01.069-.01.105-.188-.07-.374-.134-.566-.215a4.3,4.3,0,0,1-1.186-.64,3,3,0,0,1-.362-.368,11.454,11.454,0,0,1-1.928.794,11.751,11.751,0,0,1-2.614.479,14.351,14.351,0,0,1-1.835-.012c-.655-.03-1.324-.093-1.991-.159A5.247,5.247,0,0,1,7.79,2.553Zm4.651,7.471a4.408,4.408,0,0,1-1.285-.662,4.2,4.2,0,0,1-.449-.395c-.293.128-.594.247-.9.354a12.987,12.987,0,0,1-2.011.54,13.021,13.021,0,0,1-2.229.171c-.7.011-1.294-.023-2.376-.085l-.18-.011a5.18,5.18,0,0,1-.333-1l.512.032c1.156.066,1.7.1,2.356.085a12.765,12.765,0,0,0,2.188-.168,12.684,12.684,0,0,0,1.968-.528c.325-.116.648-.245.961-.385l.087-.039.064.069a3.888,3.888,0,0,0,.481.435,4.186,4.186,0,0,0,1.214.624c.106.037.214.07.323.1a5.209,5.209,0,0,1-.324.881C12.489,10.039,12.465,10.033,12.441,10.024ZM11.015,11.9c-.127-.06-.253-.124-.374-.195a4.584,4.584,0,0,1-.517-.359,11.625,11.625,0,0,1-1.856.482,16.629,16.629,0,0,1-2.163.2c-.236.011-.589.018-1.229.033l-.11,0a5.2,5.2,0,0,1-.8-.7l.568-.012c.714-.016,1.108-.025,1.369-.037a18.129,18.129,0,0,0,2.385-.216,12.775,12.775,0,0,0,2.1-.553l.071-.025.057.048a4.811,4.811,0,0,0,.6.425,4.663,4.663,0,0,0,.569.287A5.281,5.281,0,0,1,11.015,11.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlaFlagFacilitet);
export default __webpack_public_path__ + "static/media/BLA-FLAG-FACILITET.b028b5045940a7dcd33c9bdf340bb95e.svg";
export { ForwardRef as ReactComponent };